/* eslint-disable */
import CONSTANT from '../Constant';
import Utils from '../Utils';
import db from '../firebaseInit'
import firebase from 'firebase'

// eslint-disable
export default class DateRecipeService {

    constructor(){
        db.firestore.settings({ timestampsInSnapshots: true });
    }
    
    // READ
    static getDateRecipes(callback) {
        
        var query = db.collection(CONSTANT.COLLECTIONS.DATE_RECIPES);
        query.onSnapshot((querySnapshot) => {
            if (!querySnapshot.empty) {
                callback(querySnapshot);
            } else {
                console.log("No such document!");
                callback(null);
            }
        }, err => {
            console.log(`Encountered error: ${err}`);
            callback(null);
        });
    }

    static getRecipeById(id, callback) {
        if (id) {
            db.collection(CONSTANT.COLLECTIONS.DATE_RECIPES).doc(id)
            .onSnapshot((querySnapshot) => {
                if (querySnapshot.exists && querySnapshot.data()) {
                    var _recipe  = querySnapshot.data();
                    callback(_recipe);
                } else {
                    console.log("No such document!");
                    callback(null);
                }
            });
        } else {
            callback(null);   
        }
    }

    // ADD, EDIT, DELETE

    static addEditRecipe(recipeInfo, id) {

        if (!id) {
            return new Promise((resolve) => {
                var UUID = Utils.generateUUID();
                recipeInfo.id = UUID;
                recipeInfo.published_date = Utils.getFirebaseTimestamp();
                recipeInfo.modified_date = Utils.getFirebaseTimestamp();
                
                db.collection(CONSTANT.COLLECTIONS.DATE_RECIPES).doc(UUID).set(recipeInfo)
                .then(docRef => {
                    console.log('Recipe written with ID: ', UUID)
                    resolve(UUID);
                })
                .catch(function (error) {
                    console.error('Error adding recipe: ', error)
                })
            });

        } else {
            return new Promise((resolve) => {
                recipeInfo.modified_date = Utils.getFirebaseTimestamp();
                db.collection(CONSTANT.COLLECTIONS.DATE_RECIPES).doc(id).set(recipeInfo)
                    .then(docRef => {
                        console.log('Recipe updated : ', id)
                        resolve(docRef);
                    })
                    .catch(function (error) {
                        console.error('Error updating recipe: ', error)
                    })
            })
        }
    }  
}
